export default ({ enrollmentsSelectedUsers }) => enrollmentsSelectedUsers.data.count || 0;
